import { Employee } from 'nomst/Stores/Decision/employee';

export class EmployeeDispatcher {

    private _employee: Employee;

    constructor(employee: Employee) {
        this._employee = employee;
    }

    async dispatchSaveEmployeeDecisions(
        masterAccountId: string,
        cycleId: number,
        budgetCycleId: number,
        employeeSourceId: string,
        bonusFieldDecisions: IBonusFieldRule[]): Promise<void> {
        await this._employee.saveEmployeeMultiFactorBonusDecision(
            masterAccountId,
            cycleId,
            budgetCycleId,
            employeeSourceId,
            bonusFieldDecisions);
    }

    calculatePayRange(job: IJobNoMst): void {
        this._employee.calculatePayRange(job);
    }
}
